import { Agent } from "../../../model/Agent";

const AGENT_SET = 'AGENT/SET';

export default function agentSetAction(agent: Agent) {
  return {
    type: AGENT_SET,
    payload: {
      agent: agent,
    },
  };
}

export { AGENT_SET };
